function splitEntryLines(entries: Array<string | null | undefined> | undefined): string[] {
  return (entries ?? [])
    .flatMap((entry) => (entry ?? "").split("\n"))
    .map((line) => line.trim())
    .filter((line) => !!line);
}

/**
 * One caption for a step of the Zeitleiste in its compact phone layout: every recorded time, then
 * who recorded the step, e.g. "27.09.26 14:04, 27.09.26 13:28 · IRES_ADMIN".
 *
 * Times and people are listed apart, as the desktop table shows them in separate columns. An
 * appointment step stores several times in one multi-line entry, and its creator list drops the
 * missing ones, so pairing a time with a person line by line could name the wrong one.
 *
 * @param stepCreationTimestamps The row's formatted times; an entry may hold several lines.
 * @param stepCreators The row's creator nicknames; an entry may hold several lines.
 * @returns The caption, or an empty string when the step has neither.
 */
export function formatTimelineStepSummary(
  stepCreationTimestamps: Array<string | null | undefined> | undefined,
  stepCreators: Array<string | null | undefined> | undefined
): string {
  const timestamps = splitEntryLines(stepCreationTimestamps);
  const creators = Array.from(new Set(splitEntryLines(stepCreators)));

  return [timestamps.join(", "), creators.join(", ")].filter((part) => !!part).join(" · ");
}
